import { useTranslation } from 'react-i18next';

/**
 * Returns locale-aware formatting helpers based on the current i18n language.
 * Use these instead of hardcoded "fr-FR" locale strings.
 */
export function useLocaleFormat() {
  const { i18n } = useTranslation();
  const locale = i18n.language === 'ar' ? 'ar-DZ' : 'fr-FR';

  const formatNumber = (value: number, options?: Intl.NumberFormatOptions) =>
    new Intl.NumberFormat(locale, options).format(value);

  const formatCurrency = (value: number, currency = 'DZD') =>
    new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
    }).format(value);

  const formatDate = (
    date: Date | string | number,
    options?: Intl.DateTimeFormatOptions
  ) =>
    new Intl.DateTimeFormat(locale, options).format(
      typeof date === 'string' || typeof date === 'number'
        ? new Date(date)
        : date
    );

  const formatDateTime = (date: Date | string | number) =>
    formatDate(date, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });

  const formatDateShort = (date: Date | string | number) =>
    formatDate(date, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });

  return { locale, formatNumber, formatCurrency, formatDate, formatDateTime, formatDateShort };
}
